import { render, staticRenderFns } from "./indexNew.vue?vue&type=template&id=91d174e2"
import script from "./indexNew.vue?vue&type=script&lang=js"
export * from "./indexNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91d174e2')) {
      api.createRecord('91d174e2', component.options)
    } else {
      api.reload('91d174e2', component.options)
    }
    module.hot.accept("./indexNew.vue?vue&type=template&id=91d174e2", function () {
      api.rerender('91d174e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/deptUserTree/indexNew.vue"
export default component.exports